import React, { useState } from "react";
import "../Styles/Home.css";
import logoMain from "../Assets/logoNH7.png";
import Barmenu from "../Assets/foodMenu/Barmenu.jpg";
import foodMenu from "../Assets/foodMenu/foodMenu.webp";
import MenuTikkiBar from "../Assets/foodMenu/MenuTikkiBar.webp";
import MenuMojitoBar from "../Assets/foodMenu/MojitoBar.png";
import rb from "../Assets/foodMenu/rb.svg";
import mb from "../Assets/foodMenu/mb.svg";
import back from "../Assets/back.svg";
import tb from "../Assets/foodMenu/tb.svg";
import fb from "../Assets/foodMenu/fb.svg";
import Accordion from 'react-bootstrap/Accordion';

const BarFoodMenu = () => {
  return (
    <div>
      <div>
          <a href="/" className="fBack">
            <img src={back} className="backBtn" alt="back button"></img>
          </a>
        </div>
      <section className="height_custom">
        <div className="alignCenter">
          <a href="/">
            <img
              src={logoMain}
              className="logoMain_pages"
              alt="nh7 Weekender logo"
            ></img>
          </a>
        </div>
        <div className="bf_menu">
        <Accordion defaultActiveKey="0">
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>
                            <img src={rb} className="title_lineup" alt="Regular bar Menu"></img>
                        </Accordion.Header>
                        <Accordion.Body>
                        <img src={Barmenu} className="menucard" alt="Weekender Bar Menu"></img>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header>
                            <img src={tb} className="title_lineup" alt="Menu Tikki Bar"></img>
                        </Accordion.Header>
                        <Accordion.Body>
                        <img src={MenuTikkiBar} className="menucard" alt="Weekender Menu Tikki Bar"></img>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2">
                        <Accordion.Header>
                            <img src={mb} className="title_lineup" alt="Menu Mojito bar"></img>
                        </Accordion.Header>
                        <Accordion.Body>
                        <img src={MenuMojitoBar} className="menucard" alt="Weekender Menu Mojito Bar"></img>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3">
                        <Accordion.Header>
                            <img src={fb} className="title_lineup" alt="Food menu"></img>
                        </Accordion.Header>
                        <Accordion.Body>
                        <img src={foodMenu} className="menucard foodMenu" alt="Weekender Food Menu"></img>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            
           
            
        </div>
      </section>
    </div>
  );
};

export default BarFoodMenu;
